export default __webpack_public_path__ + "static/media/orabank.8fa55eae.png";